var map = {
	"./bounce/blocks": 2463,
	"./calc/blocks": 2464,
	"./craft/agent/blocks": 2466,
	"./craft/code-connection/blocks": 2467,
	"./craft/designer/blocks": 2281,
	"./craft/simple/blocks": 2465,
	"./dance/blocks": 1744,
	"./eval/blocks": 2468,
	"./flappy/blocks": 2469,
	"./jigsaw/blocks": 2475,
	"./maze/blocks": 2478,
	"./p5lab/spritelab/blocks": 1627,
	"./sites/studio/pages/blocks": 2489,
	"./studio/blocks": 2288,
	"./turtle/blocks": 2485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2918;